// extracted by mini-css-extract-plugin
export var column = "MarkdownColumn-module--column--68bc0";